import { CircularProgress, Collapse, Divider, Link, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {makeStyles} from "@material-ui/styles";
import {Add, ExpandLess, ExpandMore, Remove} from "@material-ui/icons";
import EmploymentHistoryFields from "../acordionFields/EmploymentHistoryFields";
import RegisteredEmploymentHistoryFields from "../acordionFields/RegisteredEmploymentHistoryFields";
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));
const Employment = (props) => {
  const classes = useStyles();

  const[registeredEmploymentsHistoryAccordion, setRegisteredEmploymentsHistoryAccordion] = useState(false);
  const[currentCompaniesAccordion, setCurrentCompaniesAccordion] = useState(false);
  const[employmentsHistoryAccordion, setEmploymentsHistoryAccordion] = useState(false);
  const [registeredEmploymentHistory, setRegisteredEmploymentHistory] = useState([]);

  const [statusRegisteredEmploymentHistory, setStatusRegisteredEmploymentHistory] = useState('fetching');
  const [statusEmplymentHistory, setStatusEmplymentHistory] = useState('fetching');

  const {
    employmentHistory,
    setEmploymentHistory,
    handleAddNestedFields,
    handleRemoveNestedFields,
    handleNestedFieldChange,
    tabNumber,
    contactId,
    handleTabChange,
    tab,
    itemType,
    adminUserSession,
  } = props;

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${contactId}/ria_employment_history`,
      {
        params: { entity_type: itemType },
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { ria_employment_history, status } = response.data;

      setEmploymentHistory(ria_employment_history);
      setStatusEmplymentHistory(status);
    });
  }, []);

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${contactId}/ria_registered_employment_history`,
      {
        params: { entity_type: itemType },
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { ria_registered_employment_history, status } = response.data;

      setRegisteredEmploymentHistory(ria_registered_employment_history);
      setStatusRegisteredEmploymentHistory(status);
    });
  }, []);

  const nestedFieldsName = itemType === 'IA' ? 'employmentHistory' : 'employmentHistoryBrokerDealer'

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event,  tabNumber)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === tabNumber ? classes.tabActive : ''}`}>Employment</Typography>
        {statusRegisteredEmploymentHistory !== 'fetched' || statusEmplymentHistory !== 'fetched' ? <CircularProgress /> : ''}
        {tab === tabNumber ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === tabNumber}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            <div className={classes.employmentContainer}>
              <Typography variant='h5' className={classes.innerSectionTitle}  onClick={() => setEmploymentsHistoryAccordion(!employmentsHistoryAccordion)}>
                Employment History
                <span className={classes.headerIconContainer}>{employmentsHistoryAccordion ? <Remove /> : <Add /> }</span>
              </Typography>

              <Collapse in={employmentsHistoryAccordion} className={classes.innerSectionCollapse}>

                {employmentHistory.map((props) => <EmploymentHistoryFields key={props.id} employment={props} onChange={handleNestedFieldChange} onClick={handleRemoveNestedFields} />)}

                <Link to='' className={classes.addNewRelationshipLink} onClick={(event) => handleAddNestedFields('employment', nestedFieldsName)}>+ New Past Employment</Link>
              </Collapse>
            </div>
            <Divider />
            <div className={classes.employmentContainer}>
              <Typography variant='h5' className={classes.innerSectionTitle} onClick={() => setRegisteredEmploymentsHistoryAccordion(!registeredEmploymentsHistoryAccordion)}>
                Employment History - Registered
                <span className={classes.headerIconContainer}>{ registeredEmploymentsHistoryAccordion ? <Remove /> : <Add /> }</span>
              </Typography>

              <Collapse in={registeredEmploymentsHistoryAccordion} className={classes.innerSectionCollapse}>
                {registeredEmploymentHistory.map((props) => <RegisteredEmploymentHistoryFields key={`${itemType}-${props.id}`} employment={props} />)}
              </Collapse>
            </div>
            <Divider />
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default Employment;